import type { ICoupon } from '../types/coupon';
import { create } from 'zustand';

interface CouponStoreState {
  couponCode: string;
  coupons?: ICoupon[];
  isFetchingCoupon: boolean;
}

interface CouponStoreAction {
  setCouponCode: (value: string) => void;
  addCoupon: (value: ICoupon) => void;
  setCoupons: (value: ICoupon[]) => void;
  setIsFetchingCoupon: (value: boolean) => void;
}

interface CouponStoreGetters {
  getActiveCoupon: () => ICoupon | undefined;
  checkCouponCode: (value: string) => boolean;
}

type CouponStore = CouponStoreState & CouponStoreAction & CouponStoreGetters;
export const usePricingCouponStore = create<CouponStore>((set, get) => ({
  coupons: undefined,
  couponCode: '',
  isFetchingCoupon: false,

  setCouponCode: (val: string) => {
    set(() => ({ couponCode: val }));
  },
  addCoupon: (val: ICoupon) => {
    set((state) => ({ coupons: [...(state.coupons || []), val] }));
  },
  setCoupons: (val: ICoupon[]) => {
    set(() => ({ coupons: val }));
  },
  setIsFetchingCoupon: (val: boolean) => {
    set(() => ({ isFetchingCoupon: val }));
  },
  getActiveCoupon: () => {
    return get().coupons?.find((coupon) => coupon.code === get().couponCode);
  },
  checkCouponCode: (val: string) => {
    return get().coupons?.some((coupon) => coupon.code === val) ?? false;
  },
}));
